import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';
import ArticleCard from '../../articles/components/ArticleCard';
import articleData from '../../../data/articleData';

const { FiArrowRight } = FiIcons;

function ArticlesSection() {
  const navigate = useNavigate();
  const featuredArticles = articleData.slice(0, 3);

  return (
    <section id="articles" className="py-24">
      <div className="container-custom">
        {/* 🚀 優化：與其他區塊保持一致 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            深度文章
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400 max-w-2xl mx-auto">
            探索更多關於 Omakase 文化的精彩內容
          </p>
        </motion.div>

        {/* 🚀 優化：移除 grid 的動畫，讓卡片自己處理 */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {featuredArticles.map((article, index) => (
            <motion.div
              key={article.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <ArticleCard article={article} />
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.3 }}
          className="text-center"
        >
          <button
            onClick={() => navigate('/articles')}
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white rounded-full font-medium shadow-lg hover:shadow-xl transition-all duration-300"
          >
            查看所有文章
            <SafeIcon icon={FiArrowRight} />
          </button>
        </motion.div>
      </div>
    </section>
  );
}

export default ArticlesSection;